<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="12"
  viewBox="8 6 18 18"
  ><g
    stroke-linecap="square"
    stroke-linejoin="miter"
    stroke-width="2"
    fill="#FFFFFF"
    stroke="#FFFFFF"
    ><line
      fill="none"
      stroke="#FFFFFF"
      stroke-miterlimit="10"
      x1="22"
      y1="10"
      x2="10"
      y2="22"
    />
    <line
      fill="none"
      stroke="#FFFFFF"
      stroke-miterlimit="10"
      x1="22"
      y1="22"
      x2="10"
      y2="10"
    /></g
  ></svg
>
